const AdvisorModalContent = {
  contactAdvisorTitle: <h4>Contact your advisor for assistance.</h4>,

  contactAdvisorDescription: (
    <p>
      Please reach out to your advisor to discuss potential impacts on your
      financial plan if you withdraw from your account(s). They can also assist
      you in making the transaction.
    </p>
  ),

  minMaxContactAdvisorTitle: (
    <h4>Need to withdraw more than your daily max?</h4>
  ),

  minMaxContactAdvisorDescription: (
    <p>
      Your daily max is set up to keep you aligned to your current financial
      plan. Please reach out to your advisor about impacts to your plan and they
      will be able to assist you in a specific withdrawal.{' '}
    </p>
  ),
};

export default AdvisorModalContent;
